import {
  all,
  fork,
  put,
  takeEvery,
} from 'redux-saga/effects';

import { performApiGet } from '../../../core/utils/sagaUtils';
import {
  initialize,
  setAttachList,
  setResultDetails,
} from './actions';
import {
  AttachInfo,
  RequestAttachListArgs,
  RequestResultDetailsArgs,
  ResultDetailsAction,
  ResultDetailsActionConstants,
  ResultDetailsInfo,
} from './types';

function* initializeFlow() {
  yield put(initialize());
}

function* requestResultDetailsFlow() {
  yield takeEvery(ResultDetailsActionConstants.RESULT_DETAILS_REQUEST,
    function* _(act: ResultDetailsAction<RequestResultDetailsArgs>) {
      yield fork((
        id,
      ) => performApiGet<ResultDetailsInfo>(
        'v1/Result/GetResultDetails', {
          params: {
            id,
          },
          onResult: ({ result, error }) => put(setResultDetails({
            resultDetails: result,
            error,
          })),
        },
      ),
      act.id);
    });
}

function* requestAttachListFlow() {
  yield takeEvery(ResultDetailsActionConstants.ATTACH_LIST_REQUEST,
    function* _(act: ResultDetailsAction<RequestAttachListArgs>) {
      yield fork((
        resultDetailId,
      ) => performApiGet<AttachInfo[]>(
        'v1/Result/GetAttachList', {
          params: {
            resultDetailId,
          },
          onResult: ({ result, error }) => put(setAttachList({
            result,
            error,
          })),
        },
      ),
      act.resultDetailId);
    });
}

export default function* resultDetailsSaga() {
  yield all([
    initializeFlow(),
    requestResultDetailsFlow(),
    requestAttachListFlow(),
  ]);
}
